module.exports = __webpack_public_path__ + "media/lpq_4x5.d3522b94.mp4";